module.exports = __webpack_public_path__ + "static/media/styled.1c27d9d9.png";